{{#if isFixedDate}}
    <div class="row">
        <div class="col-xs-12 col-sm-6">
            <div class="input-group date">
                <input type="text" class="form-control {{#if size}}input-{{size}}{{/if}} js-fv-tb-2 js-datepicker" value="{{valueDate}}" data-fvid="{{fvid}}">
                </input>
                <span class="input-group-addon b-0 btn-white">
                    <i class="fa fa-calendar"></i>
                </span>
            </div>
        </div>
        <div class="col-xs-12 col-sm-6">
            <div class="input-group bootstrap-timepicker timepicker">
                <input type="text" class="form-control {{#if size}}input-{{size}}{{/if}} js-fv-tb-2 js-timepicker" value="{{valueTime}}" data-fvid="{{fvid}}">
                <span class="input-group-addon b-0 btn-white">
                    <i class="fa fa-clock-o"></i>
                </span>
            </div>
        </div>
    </div>
{{/if}}
{{#if isFieldData}}
    <div class="row">
        <div class="col-xs-12 col-sm-12">
            {{#if isFieldDataTypeEnum}}
            <div class="input-group">
                {{#SELECT value}}
                <select class="selectpicker js-fv-sel-1" data-style="btn-white {{#if size}}btn-{{size}}{{/if}}" data-fvid="{{fvid}}">
                    {{#each fieldDataEnumItems}}
                    <option value="{{value}}">{{text}}</option>
                    {{/each}}
                </select>
                {{/SELECT}}
            </div>
            {{else}}
            <div class="input-group">
                <input type="text" class="form-control {{#if size}}input-{{size}}{{/if}} js-fv-tb-3" value="{{value}}" data-fvid="{{fvid}}">
                <span class="input-group-addon b-0">
                    {{valueUnit}}
                </span>
            </div>
            {{/if}}
        </div>
    </div>
{{/if}}
{{#if isFixedText}}
    {{#if isFixedTextSelect}}
    {{#SELECT value}}
    <select class="selectpicker js-fv-sel-1" data-style="btn-white {{#if size}}btn-{{size}}{{/if}}" data-fvid="{{fvid}}">
        {{#each fieldTextSelectOptions}}
        <option value="{{this}}">{{this}}</option>
        {{/each}}
    </select>
    {{/SELECT}}
    {{else}}
    <input type="text" class="form-control {{#if size}}input-{{size}}{{/if}} js-fv-tb-1" value="{{value}}" data-fvid="{{fvid}}">
    {{/if}}
{{/if}}
